<template>
	<div class="allback">
		<div class="banner">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for='(item,index) in banners'>
						<div class="bannerInner clearfix"><img :src="baseurl + item.imageUrl" class="bannerImg" /></div>
					</div>
				</div>
			</div>
			<div class="zyzy_indexuser boxShadow" v-if="!needLogin">
				<div class="zyzy_indexuser_avator">
					<img :src="baseurl + userinfo.iconurl" v-if="userinfo.iconurl" class="centerhead" />
					<img src="@/images/headportrait.png" v-if="!userinfo.iconurl" class="centerhead" />
				</div>
				<div class="zyzy_indexuser_nameP1">
					{{userinfo.name}}
				</div>
				<div class="zyzy_indexuser_nameP2">
					{{userinfo.deptName || '暂无班级信息'}}
				</div>
				<div class="zyzy_indexuser_navs clearfix">
					<div class="zyzy_indexuser_nav" @click="tocenter(1)">
						<img src="@/images/zy_index1.png" />
						<div class="zyzy_indexuser_navname">个人中心</div>
					</div>
					<div class="zyzy_indexuser_nav" @click="tologout()">
						<img src="@/images/zy_index2.png" />
						<div class="zyzy_indexuser_navname">安全退出</div>
					</div>
				</div>
				<div class="zyzy_indexuser_studytime">
					您已学习<span>{{userstudy}}</span>
				</div>
			</div>
			<div class="zyzy_indexuser boxShadow" v-if="needLogin">
				<div class="zyzy_indexuser_avator">
					<img src="@/images/headportrait.png" class="centerhead" />
				</div>
				<div class="zyzy_indexlogin">
					<el-form ref="loginForm" :model="user" :rules="rules" class="loginForm">
						<el-form-item prop="username" class="elform login_form">
							<el-input prefix-icon="el-icon-user-solid" v-model="user.username" placeholder="请输入用户名/学号" class="input login_input"></el-input>
						</el-form-item>
						<el-form-item prop="password" class="elform login_form_1">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="user.password" placeholder="请输入密码" class="input login_input"></el-input>
						</el-form-item>
						<el-button type="primary" class="loginButton" @click="submitForm()">登录</el-button>
					</el-form>
				</div>
			</div>
		</div>
		<div class="zy_index_news" v-for="(item,index) in noticeList" v-if="index == 0" @click="toDetails(item)" v-show="!needLogin">
			<img :src="baseurl + item.cover" />
			<div class="zy_new_rightinfoP1 text-ellipsis">{{item.title}}</div>
			<div class="zy_new_rightinfoP2 text-ellipsistwo">{{item.contextText}}</div>
			<div class="zy_new_rightinfoP3" v-show='false' v-html="item.context"></div>
		</div>
		<div class="zy_index_quick zy_content">
			<img src="@/images/quick3.png" class="zy_index_quickback" />
			<div class="zy_index_quicktitle"><i>快捷入口</i></div>
			<div class="zy_index_quickitems">
				<div class="zy_index_quickitem" @click="toNav('courses')">
					<img src="@/images/quick1.png" class="zy_index_quickitemback zy_index_quickitemback1" />
					<img src="@/images/quick2.png" class="zy_index_quickitemback zy_index_quickitemback2" />
					<img src="@/images/quick_nav1.png" class="zy_index_quickitemicon" />
					<div class="zy_index_quickitemname">课程中心</div>
				</div>
				<div class="zy_index_quickitem" @click="toNav('tasklist')">
					<img src="@/images/quick1.png" class="zy_index_quickitemback zy_index_quickitemback1" />
					<img src="@/images/quick2.png" class="zy_index_quickitemback zy_index_quickitemback2" />
					<img src="@/images/quick_nav2.png" class="zy_index_quickitemicon" />
					<div class="zy_index_quickitemname">在线作业</div>
				</div>
				<div class="zy_index_quickitem" @click="toNav('examinelist')">
					<img src="@/images/quick1.png" class="zy_index_quickitemback zy_index_quickitemback1" />
					<img src="@/images/quick2.png" class="zy_index_quickitemback zy_index_quickitemback2" />
					<img src="@/images/quick_nav3.png" class="zy_index_quickitemicon" />
					<div class="zy_index_quickitemname">在线考试</div>
				</div>
				<div class="zy_index_quickitem" @click="toNav('center',{activeTab: 5})">
					<img src="@/images/quick1.png" class="zy_index_quickitemback zy_index_quickitemback1" />
					<img src="@/images/quick2.png" class="zy_index_quickitemback zy_index_quickitemback2" />
					<img src="@/images/quick_nav4.png" class="zy_index_quickitemicon" />
					<div class="zy_index_quickitemname">错题集</div>
				</div>
				<div class="zy_index_quickitem" @click="toNav('communication')">
					<img src="@/images/quick1.png" class="zy_index_quickitemback zy_index_quickitemback1" />
					<img src="@/images/quick2.png" class="zy_index_quickitemback zy_index_quickitemback2" />
					<img src="@/images/quick_nav5.png" class="zy_index_quickitemicon" />
					<div class="zy_index_quickitemname">交流互动</div>
				</div>
				<div class="zy_index_quickitem" @click="toNav('livelist')">
					<img src="@/images/quick1.png" class="zy_index_quickitemback zy_index_quickitemback1" />
					<img src="@/images/quick2.png" class="zy_index_quickitemback zy_index_quickitemback2" />
					<img src="@/images/quick_nav6.png" class="zy_index_quickitemicon" />
					<div class="zy_index_quickitemname">在线直播</div>
				</div>
			</div>
		</div>
		<div class="zy_index_courses zy_content clearfix">
			<div class="zy_index_coursesleft">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/title_name1.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<div class="zy_index_titlerightitem" :class="majorId == majorIdForAll ?'active':''" @click="typeChange(majorIdForAll)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo">全部</div>
						</div>
						<div class="zy_index_titlerightitem" :class="item.id == majorId ?'active':''" v-for="(item, index) in majorList" :key="'type' + index" v-if="index < 6" @click="typeChange(item.id)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo text-ellipsis">{{item.name}}</div>
						</div>
					</div>
				</div>
				<div class="zy_index_collapse clearfix">
					<div v-if="!publicCourses || publicCourses.length<=0" class="simulation_empty_msg_content">暂无课程</div>
					<div class="zy_index_collapseitem clearfix" @click="courseId = item.id" :class="courseId == item.id?'active':''" v-for="(item, index) in publicCourses" v-if="index<5">
						<div class="zy_index_collapseitemname text-ellipsis">{{item.name}}</div>
						<div class="zy_index_collapsecont" v-show='courseId == item.id'>
							<div class="zy_index_collapsecontimg">
								<el-image :src="baseurl + item.banner" style="width: 100%;height: 100%;"></el-image>
							</div>
							<div class="zy_index_collapseconttitle text-ellipsis">{{item.name}}</div>
							<div class="zy_index_collapsecontdesc">{{item.info}}</div>
							<img src="@/images/zy_course_in.png" class="zy_index_collapsein" @click="toCourseindex(item)" v-show='courseId == item.id' />
						</div>
					</div>
				</div>
			</div>
			<div class="zy_index_coursesright clearfix">
				<img src="@/images/index_course_back.png" class="zy_index_coursesrightback" />
				<div class="zy_index_coursesname">最新课程</div>
				<div v-if="!courses || courses.length<=0" class="simulation_empty_msg_content">暂无课程</div>
				<div class="zy_index_course" v-for="(item, index) in courses" v-if="index<3" @click="toCourseindex(item)">
					<div class="zy_index_courseimg">
						<el-image :src="baseurl + item.banner" style="width: 100%;height: 100%;"></el-image>
					</div>
					<div class="zy_index_courseP1 text-ellipsis">{{item.name}}</div>
					<div class="zy_index_courseP2 clearfix">
						<img src="@/images/zy_index_study.png" /> {{addCount(item) || 0}}人已学习
					</div>
				</div>
			</div>
		</div>
		<div class="zy_index_topic zy_content clearfix" v-show="!needLogin">
			<div class="zy_index_title">
				<img src="@/images/title_back1.png" class="zy_index_titleback" />
				<img src="@/images/title_name2.png" class="zy_index_titlename" />
			</div>
			<div class="zy_index_study clearfix">
				<div class="zy_index_studytype">
					<img src="@/images/study1.png" class="zy_index_studyback" />
					<img src="@/images/studynam1.png" class="zy_index_studyname" />
					<img src="@/images/zy_more.png" class="zy_index_studymore" @click="toName('tasklist')" />
				</div>
				<div v-if="!taskList || taskList.length<=0" class="simulation_empty_msg_content">暂无作业</div>
				<div class="zy_index_studyitem" v-for="item in taskList">
					<img src="@/images/study2.png" class="zy_index_studyitemback" />
					<div class="zy_index_studyitemcont">
						<div class="zy_index_studyitemname">
							<img src="@/images/zy_point_s.png" class="zy_index_studyitemicon" /> {{item.name}}
						</div>
						<div class="zy_index_studyiteminfo">
							<span>总题数：{{item.topicNum}}题</span>
							<span>总分：{{item.sumScore}}分</span>
							<span>及格分：{{item.passScore}}分</span>
							<span>创建时间：{{item.createTime | spliceForTask}}</span>
						</div>
					</div>
					<img src="@/images/study_1.png" class="zy_index_studyitemin active" v-if="!item.isFinish" @click="start(item)" />
					<img src="@/images/study_2.png" class="zy_index_studyitemin" v-if="item.isFinish" />
				</div>
			</div>
			<div class="zy_index_study">
				<div class="zy_index_studytype">
					<img src="@/images/study1.png" class="zy_index_studyback" />
					<img src="@/images/studynam2.png" class="zy_index_studyname" />
					<img src="@/images/zy_more.png" class="zy_index_studymore" @click="toName('examinelist')" />
				</div>
				<div v-if="!examList || examList.length<=0" class="simulation_empty_msg_content">暂无考试</div>
				<div class="zy_index_studyitem" v-for="item in examList">
					<img src="@/images/study2.png" class="zy_index_studyitemback" />
					<div class="zy_index_studyitemcont">
						<div class="zy_index_studyitemname">
							<img src="@/images/zy_point_s.png" class="zy_index_studyitemicon" /> {{item.name}}
						</div>
						<div class="zy_index_studyiteminfo">
							<span>考核时间：{{item.beginTime | spliceForTask}} 至 {{item.endTime | spliceForTask}}</span>
							<span>限时：{{item.timeSpent}}分钟</span>
						</div>
					</div>
					<img src="@/images/study_3.png" class="zy_index_studyitemin active" v-if="item.state == 0 || item.state == 3" @click="startexamine(item)" />
					<img src="@/images/study_4.png" class="zy_index_studyitemin" v-if="item.state == 1" />
				</div>
			</div>
		</div>
		<div class="zy_index_topic zy_content clearfix" v-show="!needLogin">
			<div class="zy_index_title">
				<img src="@/images/title_back1.png" class="zy_index_titleback" />
				<img src="@/images/title_name3.png" class="zy_index_titlename" />
				<div class="zy_index_titleright clearfix">
					<div class="zy_index_titlerightitem" @click="toName('livelist')">
						<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
						<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
						<div class="zy_index_titlerightinfo">更多</div>
					</div>
				</div>
			</div>
			<div class="zy_lives clearfix">
				<div v-if="!livelist || livelist.length<=0" class="simulation_empty_msg_content">暂无直播</div>
				<div class="zy_liveitem " v-for="(item,index) in livelist" @click="tolive(item)">
					<div class="live_img">
						<div class="live_status">
							<span class="ing" v-show="item.state == 1">·</span>
							<span v-show="item.state == 0">未开播</span>
							<span v-show="item.state == 1">已开播</span>
							<span v-show="item.state == 2">已结束</span>
						</div>
						<div class="box blury-card">
							<img :src="baseurl + item.roomPic" class="live_img1" />
							<div class="frame">
								<h2>Live online</h2>
								<p></p>
							</div>
						</div>
					</div>
					<div class="zy_liveinfo">
						<p class="zy_liveinfoP1">{{item.roomName}}
						</p>
						<p class="zy_liveinfoP2">
							主讲人：<span>{{item.name}}</span>
						</p>
						<p class="zy_liveinfoP2">
							直播时间：<span>{{item.startTime | parseTime('{m}-{d} {h}:{i}')}}-{{item.endTime | parseTime('{m}-{d} {h}:{i}')}}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="zy_index_topic zy_content clearfix" v-show="!needLogin">
			<div class="zy_index_title">
				<img src="@/images/title_back1.png" class="zy_index_titleback" />
				<img src="@/images/title_name4.png" class="zy_index_titlename" />
				<div class="zy_index_titleright clearfix">
					<div class="zy_index_titlerightitem" :class="planId == null ?'active':''" @click="changePlate(null)">
						<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
						<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
						<div class="zy_index_titlerightinfo">全部</div>
					</div>
					<div class="zy_index_titlerightitem" :class="item.id == planId ?'active':''" v-for="(item, index) in plates" :key="'type' + index" v-if="index < 6" @click="changePlate(item.id)">
						<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
						<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
						<div class="zy_index_titlerightinfo text-ellipsis">{{item.name}}</div>
					</div>
					<div class="zy_index_titlerightitem" @click="toName('communication')">
						<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
						<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
						<div class="zy_index_titlerightinfo">更多</div>
					</div>
				</div>
			</div>
			<div class="zy_post_box clearfix">
				<div v-if="!posts || posts.length<=0" class="simulation_empty_msg_content">暂无帖子</div>
				<div class="zy_post_item" v-for="(item,index) in posts" @click="toPost(item)">
					<div class="zy_post_itemP1">
						<img src="@/images/zy_point_l.png" class="zy_postpoint" /> {{item.title}}
					</div>
					<div class="zy_post_itemP2 text-ellipsistwo">
						{{item.remark || '暂无描述'}}
					</div>
					<div class="zy_post_itemP3">
						<span class="l">发帖人：{{item.createUser}}</span>
						<span class="l">|</span>
						<span class="l">{{item.createtime}}</span>
						<span class="l">|</span>
						<span class="l zy_color">
							#<span v-for="it in plates" v-if="item.pid == it.id">{{it.name}}</span>
						</span>
						<span class="r">
							<img src="@/images/iconshow.png" class="com_show"/>{{item.watchcount || 0}}
		  					<img src="@/images/I-iconmess2.png" class="com_mess2"/>{{item.chilnum || 0}}
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="stand_0"></div>
	</div>
</template>

<script>
	import { bannerList } from '@/api/banner'
	import { shareList, appCourseList } from '@/api/course'
	import { majormainDO, listMajorByPid } from '@/api/major'
	import { userNoticeList, userIsRead } from '@/api/notice'
	import { getsimulation } from '@/api/simulation'
	import { collectionSave } from '@/api/collection'
	import { getLiveList, joinRoomById } from '@/api/live.js'
	import { plateList } from '@/api/plate.js'
	import { postList } from '@/api/post.js'
	import { ourAllTaskList } from '@/api/task.js'
	import { getLoginUserExamList } from '@/api/examine'
	import { login, getInfo, selectStudentTime } from "@/api/user"
	import { getStorageToken } from '@/utils/auth'
	//vim
	import RequestUtils from "@/utils/im/RequestUtils";
	import conf from "@/utils/im/index";
	import StoreUtils from "@/utils/im/StoreUtils";
	import { logout } from "@/utils/im/ChatUtils";
	export default {
		name: 'index',
		data() {
			return {
				userinfo: {},
				userstudy: '',
				needLogin: false,
				courseId: '',
				page: 1,
				pageSize: 8,
				majorId: this.majorIdForAll,
				planId: null,
				majorList: [],
				plates: [],
				posts: [],
				examList: [],
				taskList: [],
				courses: [],
				publicCourses: [],
				banners: [],
				livelist: [],
				noticeList: [],
				user: {
					username: "",
					password: ""
				},
				rules: {
					username: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}]
				}
			}
		},
		created() {
			this.getBanner();
			this.getMajormainDO();
			this.getCourse();
			this.getNewsCourse();
			this.getNotice();
			this.getMyInfo();
			this.getLive();
			this.getPlateList();
			this.getPostList();
			this.getTaskList();
			this.getExamList();
		},
		mounted() {

		},
		methods: {
			addCount(item){
				var count =0
				if(item.count && !Number.isNaN(count)){
					count = item.count*1
				}
				var addNumber = 800;
				if(item.name == '针灸学' || item.name == '推拿学'){
					addNumber = 2000;
				}else if(item.name == '传统养生功法' || item.name == '保健按摩'){
					addNumber = 900;
				}else if(item.name == '推拿手法' || item.name == '足反射疗法'){
					addNumber = 1000;
				}
				return count+addNumber
			},
			startexamine(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '考试时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '考试时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'examine',
					query: {
						id: item.id
					}
				})
			},
			getExamList() {
				var data = {
					pageSize: 5,
					page: 1
				}
				getLoginUserExamList(data).then(res => {
					if(res.code == 0) {
						this.examList = res.data.listData;
					}
				})
			},
			start(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '作业时间未到！',
					})
					return;
				}
				if(nowTime > endTime && item.isDelay == '0') {
					this.$message({
						type: 'info',
						message: '作业时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'task',
					query: {
						taskId: item.id
					}
				})
			},
			getTaskList() {
				var that = this;
				var data = {
					pageSize: 5,
					page: 1
				}
				ourAllTaskList(data).then(res => {
					if(res.code == 0) {
						this.taskList = res.data.listData;
					}
				})
				ourAllTaskList({
					isFinish: 0
				}).then(res => {
					if(res.code == 0 && res.data.listData.length > 0) {
						this.$notify({
							title: '提示',
							message: '您有新的作业未完成，是否查看',
							duration: 5000,
							showClose: false,
							offset:130,
							position: 'top-right',
							onClick: function() {
								that.$notify.closeAll();
								that.toName('tasklist');
							},
						});
					}
				})
			},
			toPost(item) {
				this.$router.push({
					path: '/communicationDetails',
					query: {
						id: item.id
					}
				});
			},
			changePlate(planId) {
				if(this.planId != planId) {
					this.planId = planId;
					this.getPostList();
				}
			},
			getPostList() {
				var data = {
					current: 1,
					size: 6,
					pid: this.planId ? this.planId : null,
					flag: true,
					gid: this.majorIdForAll,
				}
				postList(data).then(res => {
					this.posts = res.data.records;
				})
			},
			getPlateList() {
				plateList({
					size: 100,
					current: 1,
					gid: this.majorIdForAll
				}).then(res => {
					this.plates = res.data.records;
				})
			},
			getLive() {
				var data = {
					page: 1,
					pageSize: 4,
				}
				getLiveList(data).then(res => {
					this.livelist = res.data.listData;
				})
			},
			getMyInfo() {
				var token = getStorageToken();
				if(token) {
					getInfo().then(res => {
						this.userinfo = res.data;
					})
					selectStudentTime().then(res => {
						this.userstudy = res.data
					})
				} else {
					this.needLogin = true;
				}
			},
			getBanner() {
				bannerList({
					major_type: "zyzy"
				}).then(res => {
					this.banners = res.data;
					this.$nextTick(function() {
						this.initBanner()
					});
				})
			},
			initBanner() {
				var mySwiper = new Swiper('.swiper-container', {
					loop: true,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false,
					},
					observer: true,
					observeParents: true,
				});
			},
			typeChange(id) {
				this.majorId = id;
				this.getCourse();
			},
			getCourse() {
				var data = {
					major_id: this.majorIdForAll,
					type_id: this.majorId == this.majorIdForAll ? null : this.majorId,
					page: this.page,
					pageSize: this.pageSize,
				}
				shareList(data).then(res => {
					if(res.code == 0) {
						this.publicCourses = res.data.listData;
						if(res.data.listData.length > 0) {
							this.courseId = res.data.listData[0].id
						}
					}
				})
			},
			getNewsCourse() {
				var data = {
					major_id: this.majorIdForAll,
					type_id: this.majorId == this.majorIdForAll ? null : this.majorId,
					page: this.page,
					pageSize: this.pageSize,
				}
				appCourseList(data).then(res => {
					if(res.code == 0) {
						this.courses = res.data.listData;
					}
				})
			},
			getMajormainDO() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(({
					data
				}) => {
					this.majorList = data;
				})
			},
			submitForm() {
				this.$refs.loginForm.validate(valid => {
					if(valid) {
						login({
							username: this.user.username,
							password: this.user.password
						}).then(res => {
							if(res.code == 'OK') {
								localStorage.setItem('token', res.data);
								getInfo(res.data).then(result => {
									window.localStorage.setItem('username', result.data.name)
								})
								this.$store.dispatch('user/openLogin', {
									loging: false
								});
								this.loginback = false;
								//location.reload()
								this.imLogin();
							} else {
								this.$message({
									message: res.msg,
									type: 'error'
								})
							}
						});
					}
				})
			},
			imLogin() {
				let im = RequestUtils.getInstance();
				im.login(this.user.username.trim(), '123456', this).then(token => {
					StoreUtils.setToken(token);
					return im.request(conf.getInitUrl(), new FormData());
				}).then(response => {
					return response.json();
				}).then(json => {
					//个人信息
					this.$store.commit("setUser", json.me);
					//好友
					this.$store.commit("setUserFriendList", json.friends);
					//群
					let chatMap = new Map();
					var groups = json.groups;
					groups.map(group => {
						group.unMessageFlag = group.unMessageFlag == '1' ? true : false
						chatMap.set(group.id, group);
					})
					this.$store.commit("setChatGroupList", groups);
					this.$store.commit("setChatMap", chatMap);
					// 刷新
					location.reload()
				}).catch(function(error) {
					//location.reload()
					console.log(error)
				});
			},
			tolive(item) {
				var data = {
					roomId: item.roomId
				}
				if(item.state == '0') {
					this.$alert('直播未开始，请稍候', '提示', {
						confirmButtonText: '确定',
						type: 'warning'
					})
				}
				if(item.state == '1') {
					this.$router.push({
						name: 'live',
						query: {
							roomId: item.roomId
						}
					})
				}
				if(item.state == '2') {
					this.$router.push({
						name: 'indexover',
						query: {
							roomId: item.roomId
						}
					})
				}
			},
			toCourseindex(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'courseindex',
						query: {
							id: item.id
						}
					})
				} else if(item.publicWelfare == '1') {
					this.$router.push({
						name: 'courseindexpublic',
						query: {
							id: item.id
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toName(name) {
				var token = getStorageToken();
				if(token) {
					if(this.$router.name != name) {
						this.$router.push({
							name: name
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toNav(name, query) {
				var token = getStorageToken();
				if(token) {
					if(this.$router.name != name) {
						this.showmenu = false;
						if(!query) {
							this.$router.push({
								name: name
							})
						} else {
							this.$router.push({
								name: name,
								query: query
							})
						}
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			getNotice() {
				var data = {
					limit: 4
				}
				userNoticeList(data).then(res => {
					if(res.code == 'OK') {
						this.noticeList = res.data.records;
						if(this.noticeList.length > 0) {
							this.$nextTick(() => {
								var noticeListfirst = this.noticeList[0]
								noticeListfirst.contextText = $('.zy_new_rightinfoP3').text();
								this.$set(this.noticeList, 0, noticeListfirst);
							})
						}
					}
				})
			},
			toDetails(item) {
				userIsRead({
					notice_id: item.id
				}).then(res => {
					console.log("已读!")
				})
				this.$router.push({
					name: "newsdetail",
					query: {
						id: item.id
					}
				})
			},
			tologout() {
				try {
					logout(this);
				} catch(err) {}
				window.localStorage.removeItem('token')
				location.reload()
			},
			tocenter(type) {
				if(this.$route.name != 'center') {
					this.showmenu = false;
					this.$router.push({
						path: '/center',
						query: {
							activeTab: type
						}
					});
				}
			},
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>